const SplitTestConstants = {
  ZRM_AI_LISTING_CREATION_FLOW: 'zrm_ai_listing_creation_flow',
  ZRM_APPLICATIONS_OPT_IN_DRIVERS: 'zrm_applications_opt_in_drivers',
} as const;

export default SplitTestConstants;
